import { initializeAutocomplete } from '../js/google_maps_autocomplete';
import '../js/upload_handler';
import '../../javascript/autosave';

// Initialize Action Cable
import { createConsumer } from '@rails/actioncable';
window.App = window.App || {};
window.App.cable = createConsumer();

// Initialize ActionText (Trix editor)
import "trix"
import "trix/dist/trix.css"  // Import Trix default styles for toolbar buttons
import "@rails/actiontext"

// Vue.js Setup - Scattered Components Approach
import { createApp } from 'vue'
import MultiLanguageEmailForm from '../components/MultiLanguageEmailForm.vue'
import BroadcastEmailsList from '../components/BroadcastEmailsList.vue'
import BroadcastEmailForm from '../components/BroadcastEmailForm.vue'
import BroadcastEmailShowView from '../components/BroadcastEmailShowView.vue'
import EmailTemplatesList from '../components/EmailTemplatesList.vue'
import EmailTemplateForm from '../components/EmailTemplateForm.vue'
import EmailTemplateShowView from '../components/EmailTemplateShowView.vue'
import EmailRulesManager from '../components/EmailRulesManager.vue'
import EmailReportsManager from '../components/EmailReportsManager.vue'
import AvatarUploader from '../components/AvatarUploader.vue'
// HeaderUploader import removed - header/cover picture hidden for now
import ProfileSidePanel from '../components/ProfileSidePanel.vue'

// Register Vue components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Mount MultiLanguageEmailForm component if element exists
  const emailFormElement = document.getElementById('multi-language-email-form')
  if (emailFormElement) {
    const app = createApp(MultiLanguageEmailForm, {
      emailContentId: emailFormElement.dataset.emailContentId,
      initialVariants: JSON.parse(emailFormElement.dataset.initialVariants || '{}'),
      templates: JSON.parse(emailFormElement.dataset.templates || '[]'),
      showTemplateSelector: emailFormElement.dataset.showTemplateSelector === 'true',
      saveUrl: emailFormElement.dataset.saveUrl,
      emailType: emailFormElement.dataset.emailType || 'broadcast'
    })
    app.mount('#multi-language-email-form')
  }

  // Mount BroadcastEmailsList component if element exists
  const emailsListElement = document.getElementById('broadcast-emails-list')
  if (emailsListElement) {
    const app = createApp(BroadcastEmailsList, {
      emails: JSON.parse(emailsListElement.dataset.emails || '[]'),
      showArchived: emailsListElement.dataset.showArchived === 'true',
      indexPath: emailsListElement.dataset.indexPath,
      newEmailPath: emailsListElement.dataset.newEmailPath
    })
    app.mount('#broadcast-emails-list')
  }

  // Mount BroadcastEmailForm component if element exists
  const broadcastFormElement = document.getElementById('broadcast-email-app')
  if (broadcastFormElement) {
    const app = createApp(BroadcastEmailForm, {
      emailContentId: broadcastFormElement.dataset.emailContentId || null,
      initialFilters: JSON.parse(broadcastFormElement.dataset.initialFilters || '{}'),
      initialUsers: JSON.parse(broadcastFormElement.dataset.initialUsers || '[]'),
      initialVariants: JSON.parse(broadcastFormElement.dataset.initialVariants || '{}'),
      initialTitle: broadcastFormElement.dataset.initialTitle || '',
      templates: JSON.parse(broadcastFormElement.dataset.templates || '[]'),
      saveUrl: broadcastFormElement.dataset.saveUrl,
      filterUrl: broadcastFormElement.dataset.filterUrl,
      cancelUrl: broadcastFormElement.dataset.cancelUrl
    })
    app.mount('#broadcast-email-app')
  }

  // Mount BroadcastEmailShowView component if element exists
  const broadcastShowElement = document.getElementById('broadcast-email-show-app')
  if (broadcastShowElement) {
    const app = createApp(BroadcastEmailShowView, {
      emailContent: JSON.parse(broadcastShowElement.dataset.emailContent || '{}'),
      indexUrl: broadcastShowElement.dataset.indexUrl,
      duplicateUrl: broadcastShowElement.dataset.duplicateUrl,
      recipientsUrl: broadcastShowElement.dataset.recipientsUrl
    })
    app.mount('#broadcast-email-show-app')
  }

  // Mount EmailTemplatesList component if element exists
  const templatesListElement = document.getElementById('email-templates-list')
  if (templatesListElement) {
    const app = createApp(EmailTemplatesList, {
      templates: JSON.parse(templatesListElement.dataset.templates || '[]'),
      showArchived: templatesListElement.dataset.showArchived === 'true',
      indexPath: templatesListElement.dataset.indexPath,
      newTemplatePath: templatesListElement.dataset.newTemplatePath
    })
    app.mount('#email-templates-list')
  }

  // Mount EmailTemplateForm component if element exists
  const templateFormElement = document.getElementById('email-template-form-app')
  if (templateFormElement) {
    const app = createApp(EmailTemplateForm, {
      templateId: templateFormElement.dataset.templateId || null,
      initialTemplateKey: templateFormElement.dataset.initialTemplateKey || '',
      initialTitle: templateFormElement.dataset.initialTitle || '',
      initialVariants: JSON.parse(templateFormElement.dataset.initialVariants || '{}'),
      saveUrl: templateFormElement.dataset.saveUrl,
      cancelUrl: templateFormElement.dataset.cancelUrl
    })
    app.mount('#email-template-form-app')
  }

  // Mount EmailTemplateShowView component if element exists
  const templateShowElement = document.getElementById('email-template-show-app')
  if (templateShowElement) {
    const app = createApp(EmailTemplateShowView, {
      template: JSON.parse(templateShowElement.dataset.template || '{}'),
      indexUrl: templateShowElement.dataset.indexUrl,
      editUrl: templateShowElement.dataset.editUrl,
      duplicateUrl: templateShowElement.dataset.duplicateUrl,
      automationRulesCount: parseInt(templateShowElement.dataset.automationRulesCount || '0')
    })
    app.mount('#email-template-show-app')
  }

  // Mount EmailRulesManager component if element exists
  const rulesManagerElement = document.getElementById('email-rules-manager-app')
  if (rulesManagerElement) {
    const app = createApp(EmailRulesManager, {
      indexPath: rulesManagerElement.dataset.indexPath,
      newPath: rulesManagerElement.dataset.newPath,
      templateKeys: JSON.parse(rulesManagerElement.dataset.templateKeys || '[]')
    })
    app.mount('#email-rules-manager-app')
  }

  // Mount EmailReportsManager component if element exists
  const reportsManagerElement = document.getElementById('email-reports-manager-app')
  if (reportsManagerElement) {
    const app = createApp(EmailReportsManager, {
      indexPath: reportsManagerElement.dataset.indexPath,
      initialCycles: JSON.parse(reportsManagerElement.dataset.initialCycles || '[]'),
      initialSelectedDays: parseInt(reportsManagerElement.dataset.initialSelectedDays || '7')
    })
    app.mount('#email-reports-manager-app')
  }

  // Mount AvatarUploader component if element exists
  const avatarUploaderElement = document.getElementById('avatar-uploader-app')
  if (avatarUploaderElement) {
    const app = createApp(AvatarUploader, {
      initialAvatarUrl: avatarUploaderElement.dataset.initialAvatarUrl,
      avatarType: avatarUploaderElement.dataset.avatarType,
      defaultAvatarSvg: avatarUploaderElement.dataset.defaultAvatarSvg,
      uploadUrl: avatarUploaderElement.dataset.uploadUrl,
      deleteUrl: avatarUploaderElement.dataset.deleteUrl,
      csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      uploadText: avatarUploaderElement.dataset.uploadText,
      uploadHint: avatarUploaderElement.dataset.uploadHint,
      uploadButtonText: avatarUploaderElement.dataset.uploadButtonText,
      uploadingText: avatarUploaderElement.dataset.uploadingText,
      deleteButtonText: avatarUploaderElement.dataset.deleteButtonText,
      deletingText: avatarUploaderElement.dataset.deletingText,
      cancelText: avatarUploaderElement.dataset.cancelText
    })
    app.mount('#avatar-uploader-app')
  }

  // HeaderUploader mount removed - header/cover picture hidden for now

  // Mount ProfileSidePanel component if element exists
  const sidePanelElement = document.getElementById('profile-side-panel-app')
  if (sidePanelElement) {
    const sidePanelApp = createApp(ProfileSidePanel)
    const sidePanelInstance = sidePanelApp.mount('#profile-side-panel-app')

    // Handle profile-trigger clicks to open side panel instead of modal
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('.profile-trigger')
      if (trigger) {
        e.preventDefault()
        const url = trigger.getAttribute('href')
        if (url) {
          sidePanelInstance.open(url)
        }
      }
    })
  }
})

// Disable file/image uploads in Trix editor (email templates are text-only)
document.addEventListener('trix-file-accept', function(event) {
  event.preventDefault();
  alert('Image uploads are disabled. Email templates support text formatting only (bold, italic, lists, links).');
});

document.addEventListener('DOMContentLoaded', () => {
  const locationInputs = ['location', 'project_location', 'want_place'];
  const fieldsExist = locationInputs.some(id => document.getElementById(id));

  if (fieldsExist) {
    const apiKey = document.querySelector('meta[name="google-maps-api-key"]').getAttribute('content');
    let googleMapsLoaded = false;
    let googleMapsLoadPromise = null;

    // Function to load Google Maps API only when needed (iOS Safari fix)
    function loadGoogleMapsAPI() {
      if (googleMapsLoadPromise) {
        return googleMapsLoadPromise;
      }

      googleMapsLoadPromise = new Promise((resolve, reject) => {
        if (googleMapsLoaded) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;

        script.onload = function() {
          googleMapsLoaded = true;
          resolve();
        };

        script.onerror = function() {
          reject(new Error('Failed to load Google Maps API'));
        };

        document.head.appendChild(script);
      });

      return googleMapsLoadPromise;
    }

    // Set up lazy initialization for each location input to prevent iOS autoscroll issue
    locationInputs.forEach(id => {
      const input = document.getElementById(id);
      if (input && !input.hasAttribute('data-autocomplete-ready')) {
        input.setAttribute('data-autocomplete-ready', 'true');

        // Initialize autocomplete only when user actually focuses the location field
        input.addEventListener('focus', async function() {
          if (!this.hasAttribute('data-autocomplete-initialized')) {
            try {
              await loadGoogleMapsAPI();
              initializeAutocomplete(id);
              this.setAttribute('data-autocomplete-initialized', 'true');
            } catch (error) {
              console.error('Failed to initialize location autocomplete:', error);
            }
          }
        }, { once: true }); // Use { once: true } to ensure it only runs once
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('#navbarToggle')
  const menu = document.querySelector('#navbarMenu')
  const sidebar = document.querySelector('.sidebar')
  const hamburger = document.querySelector('#mobileMenuToggle')
  // Must match $breakpoint-mobile in _variables.scss
  const MOBILE_BREAKPOINT = 1080

  // Avatar click - toggles profile dropdown (desktop and mobile)
  if (toggle && menu) {
    toggle.addEventListener('click', (event) => {
      event.stopPropagation()
      toggle.classList.toggle('active')
      menu.classList.toggle('navbar__menu--hidden')

      // Close sidebar if open
      if (hamburger && sidebar && sidebar.classList.contains('mobile-visible')) {
        sidebar.classList.remove('mobile-visible')
        hamburger.classList.remove('active')
      }
    })
  }

  // Hamburger click - toggles sidebar on mobile
  if (hamburger && sidebar) {
    hamburger.addEventListener('click', (event) => {
      event.stopPropagation()
      hamburger.classList.toggle('active')
      sidebar.classList.toggle('mobile-visible')

      // Close profile dropdown if open
      if (menu && !menu.classList.contains('navbar__menu--hidden')) {
        menu.classList.add('navbar__menu--hidden')
        if (toggle) toggle.classList.remove('active')
      }
    })
  }

  // Close menus when clicking outside
  document.addEventListener('click', (event) => {
    // Close mobile sidebar when clicking outside
    if (sidebar && sidebar.classList.contains('mobile-visible') &&
        !sidebar.contains(event.target) &&
        (!hamburger || !hamburger.contains(event.target))) {
      sidebar.classList.remove('mobile-visible')
      if (hamburger) hamburger.classList.remove('active')
    }

    // Close profile menu when clicking outside
    if (menu && !menu.classList.contains('navbar__menu--hidden') &&
        !menu.contains(event.target) &&
        (!toggle || !toggle.contains(event.target))) {
      menu.classList.add('navbar__menu--hidden')
      if (toggle) toggle.classList.remove('active')
    }
  })

  // Reset sidebar on window resize to desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      if (sidebar) sidebar.classList.remove('mobile-visible')
      if (hamburger) hamburger.classList.remove('active')
      if (menu && !menu.classList.contains('navbar__menu--hidden')) {
        menu.classList.add('navbar__menu--hidden')
        if (toggle) toggle.classList.remove('active')
      }
    }
  })
})

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-confirm]').forEach(function(element) {
    element.addEventListener('click', function(event) {
      var message = element.getAttribute('data-confirm');
      if (!confirm(message)) {
        event.preventDefault();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const countElement = document.getElementById('connectionRequestsCount');
  // Only proceed if the countElement is present, indicating a logged-in user context
  if (countElement) {
    // Get current locale from URL path
    const currentLocale = window.location.pathname.split('/')[1] || 'sk';
    const localePattern = /^(sk|en)$/; // Match available locales
    const locale = localePattern.test(currentLocale) ? currentLocale : 'sk'; // Default to 'sk' if not valid

    fetch(`/${locale}/connection_requests/count.json`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.count > 0) {
          countElement.textContent = data.count;
          countElement.style.display = 'inline';
        }

        const myConnectionsBadge = document.getElementById('myConnectionsBadge');
        if (myConnectionsBadge && data.has_network_requests) {
          myConnectionsBadge.style.display = 'inline';
        }

        const myProjectsBadge = document.getElementById('myProjectsBadge');
        if (myProjectsBadge && data.has_project_requests) {
          myProjectsBadge.style.display = 'inline';
        }
      })
      .catch(error => console.error('Error fetching connection requests count:', error));
  }
});

document.addEventListener('click', function(e) {
  if (e.target.matches('.modal-trigger')) {
    e.preventDefault();
    const url = e.target.getAttribute('href');
    fetch(url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('modalContent').innerHTML = html;
        document.getElementById('customModal').classList.remove('hidden');
      })
    .catch(err => console.error('Error loading modal content:', err));
  }

  if (e.target.matches('.close-button') || e.target.matches('#customModal')) {
    document.getElementById('customModal').classList.add('hidden');
  }
});

// Approval modal dismiss handler (centralized)
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.approval-modal-dismiss');
  if (!btn) return;
  e.preventDefault();
  const userId = btn.getAttribute('data-user-id');
  try {
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = date.toUTCString();
    document.cookie = `approval_notification_dismissed_${userId}=true; expires=${expires}; path=/`;
  } catch (err) {
    console.error('Failed setting approval dismissal cookie', err);
  }
  const modal = document.getElementById('customModal');
  if (modal) modal.classList.add('hidden');
  document.body.style.overflow = '';
});


// Secure File Display System (Chunk 8)
class SecureFileViewer {
  constructor() {
    this.lightbox = document.getElementById('secureLightbox');
    this.lightboxBody = this.lightbox?.querySelector('.lightbox-body');
    this.lightboxLoading = this.lightbox?.querySelector('.lightbox-loading');
    this.downloadBtn = this.lightbox?.querySelector('.lightbox-download');
    this.currentToken = null;
    this.currentFileHash = null;

    this.initEventListeners();
  }

  initEventListeners() {
    // File preview clicks
    // File preview clicks - COMMENTED OUT TO PREVENT MODAL CONFLICT
    // document.addEventListener('click', (e) => {
    //   const fileItem = e.target.closest('.file-item');
    //   if (fileItem && (e.target.closest('[data-action="preview"]') || e.target.classList.contains('file-thumbnail-placeholder'))) {
    //     this.openSecurePreview(fileItem);
    //   }
    // });

    // Lightbox close
    if (this.lightbox) {
      this.lightbox.querySelector('.lightbox-close')?.addEventListener('click', () => this.closeLightbox());
      this.lightbox.querySelector('.lightbox-backdrop')?.addEventListener('click', () => this.closeLightbox());
      this.downloadBtn?.addEventListener('click', () => this.downloadCurrentFile());
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.lightbox?.classList.contains('hidden')) {
        this.closeLightbox();
      }
    });
  }

  async openSecurePreview(fileItem) {
    const fileHash = fileItem.dataset.fileHash;
    const contentType = fileItem.dataset.contentType;
    const projectId = fileItem.dataset.projectId;

    if (!fileHash || !projectId) {
      console.error('Missing file identification data');
      return;
    }

    // Show lightbox with loading state
    this.showLightbox();
    this.showLoading();

    try {
      // Request secure token
      // Use current page locale for API requests
      const currentLocale = window.location.pathname.split('/')[1] || 'sk';
      const tokenResponse = await fetch(`/${currentLocale}/projects/${projectId}/request_file_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        },
        body: JSON.stringify({ file_hash: fileHash })
      });

      if (!tokenResponse.ok) {
        throw new Error('Failed to get file access token');
      }

      const tokenData = await tokenResponse.json();
      this.currentToken = tokenData.token;
      this.currentFileHash = fileHash;

      // Display content based on type
      if (contentType.includes('image')) {
        await this.displaySecureImage(tokenData.token);
      } else if (contentType === 'application/pdf') {
        await this.displaySecurePDF(tokenData.token);
      } else {
        this.showUnsupportedType();
      }

      // Show download button
      this.downloadBtn.style.display = 'inline-flex';

    } catch (error) {
      console.error('Secure preview failed:', error);
      this.showError('Failed to load secure content');
    }
  }

  async displaySecureImage(token) {
    const img = new Image();
    const secureUrl = `/secure/stream?t=${token}`;

    img.onload = () => {
      this.lightboxBody.innerHTML = '';
      this.lightboxBody.appendChild(img);
    };

    img.onerror = () => {
      this.showError('Failed to load image');
    };

    img.src = secureUrl;
  }

  async displaySecurePDF(token) {
    const secureUrl = `/secure/stream?t=${token}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`;
    const iframe = document.createElement('iframe');
    iframe.src = secureUrl;
    iframe.style.width = '80vw';
    iframe.style.height = '70vh';

    // SECURITY FIX: Sandbox with minimal permissions for static PDF viewing
    // allow-same-origin: Required for PDF content to load from same domain
    // Still blocks: scripts, forms, popups, top navigation (safer than allow-scripts allow-forms)
    // This prevents malicious files from executing code or accessing parent window
    iframe.sandbox = 'allow-same-origin';

    this.lightboxBody.innerHTML = '';
    this.lightboxBody.appendChild(iframe);
  }

  showLightbox() {
    this.lightbox?.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    this.lightbox?.classList.add('hidden');
    document.body.style.overflow = '';
    this.downloadBtn.style.display = 'none';
    this.currentToken = null;
    this.currentFileHash = null;
  }

  showLoading() {
    this.lightboxBody.innerHTML = '<div class="lightbox-loading"><div class="loading-spinner"></div><p>Loading secure content...</p></div>';
  }

  showError(message) {
    this.lightboxBody.innerHTML = `<div class="lightbox-error"><p>${message}</p></div>`;
  }

  showUnsupportedType() {
    this.lightboxBody.innerHTML = '<div class="lightbox-error"><p>Preview not available for this file type</p></div>';
  }


  async downloadCurrentFile() {
    if (!this.currentToken) return;

    try {
      const response = await fetch(`/secure/stream?t=${this.currentToken}`);
      const blob = await response.blob();

      // UX IMPROVEMENT: Generate filename with proper extension based on content type
      const extension = getFileExtensionFromContentType(blob.type);
      const filename = `secure_file_${Date.now()}.${extension}`;

      // Create download without exposing original filename
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  }
}

// TEMPORARILY DISABLED: Secure Download Handler (GitHub Issue #39)
// This enhanced token-based download system provides superior security but fails on mobile devices.
// We've temporarily disabled it to ensure mobile compatibility while using the HTML-only approach.
// The HTML approach via FileProxyController provides adequate security and works on all devices.
// Future enhancement tracked in: https://github.com/codecraftmario/unlisters/issues/39

/*
// Secure Download Handler - replaces old direct download (Chunk 9)
document.addEventListener('click', async function(event) {
  if (event.target.matches('.downloadButton') || event.target.closest('.downloadButton')) {
    event.preventDefault();
    event.stopPropagation(); // Prevent event bubbling to thumbnail container

    const button = event.target.closest('.downloadButton');
    const fileHash = button.dataset.fileHash;
    const projectId = button.dataset.projectId;

    // Check if this is a sidebar download
    const isSidebarDownload = button.closest('#sidebar-thumbnail-list');
    const overlay = isSidebarDownload
      ? document.getElementById('sidebar-download-overlay')
      : document.getElementById('downloadOverlay');

    if (!fileHash || !projectId) {
      console.error('Missing download parameters');
      return;
    }

    overlay.style.display = 'flex';

    try {
      // Request secure token
      // Use current page locale for API requests
      const currentLocale = window.location.pathname.split('/')[1] || 'sk';
      const tokenResponse = await fetch(`/${currentLocale}/projects/${projectId}/request_file_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        },
        body: JSON.stringify({ file_hash: fileHash })
      });

      if (!tokenResponse.ok) {
        throw new Error('Failed to get download token');
      }

      const tokenData = await tokenResponse.json();

      // Download using secure token
      const response = await fetch(`/secure/stream?t=${tokenData.token}`);
      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();

      // UX IMPROVEMENT: Generate filename with proper extension based on content type
      const extension = getFileExtensionFromContentType(tokenData.content_type);
      const filename = `secure_file_${Date.now()}.${extension}`;

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);

    } catch (error) {
      console.error('Secure download failed:', error);
    } finally {
      overlay.style.display = 'none';
    }
  }
});
*/

// Helper function to determine file extension from content type
function getFileExtensionFromContentType(contentType) {
  const mimeToExtension = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/svg+xml': 'svg',
    'image/webp': 'webp',
    'text/plain': 'txt',
    'text/csv': 'csv',
    'application/json': 'json',
    'application/xml': 'xml',
    'application/zip': 'zip',
    'application/x-zip-compressed': 'zip',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
  };

  return mimeToExtension[contentType] || 'bin';
}

// Inline File Display System (Chunk 2)
class InlineFileViewer {
  constructor() {
    this.inlineViewer = document.getElementById('inline-file-viewer');
    this.viewerTitle = document.getElementById('inline-viewer-title');
    this.viewerContent = document.getElementById('inline-viewer-content');
    this.closeBtn = document.getElementById('close-inline-viewer');
    this.fileGrid = document.querySelector('.file-grid');
    this.mainContent = document.querySelector('.main-content');
    this.sideRight = null; // Will be found dynamically
    this.thumbnailsCloned = false;
    this.currentFileId = null;

    this.initEventListeners();
  }

  initEventListeners() {
    // Handle thumbnail clicks for inline viewing
    document.addEventListener('click', (e) => {
      const thumbnail = e.target.closest('.file-thumbnail[data-action="inline"]');
      if (thumbnail) {
        e.preventDefault();
        this.openInlineView(thumbnail);
      }
    });

    // Handle close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeInlineView());
    }
  }

  async openInlineView(thumbnail) {
    const inlineUrl = thumbnail.dataset.inlineUrl;
    const fileItem = thumbnail.closest('.file-item');
    const fileName = fileItem.querySelector('.file-name')?.textContent?.trim() || 'File';
    const contentType = fileItem.dataset.contentType;
    const fileId = fileItem.dataset.fileId;

    if (!inlineUrl) {
      console.error('Missing inline URL');
      return;
    }

    // Store current file ID
    this.currentFileId = fileId;

    // Clone thumbnails to sidebar on first open
    if (!this.thumbnailsCloned) {
      this.setupSidebarThumbnails();
    }

    // Activate the viewer layout
    this.activateViewerLayout();

    // Show the inline viewer
    this.showInlineViewer();
    this.viewerTitle.textContent = fileName;
    this.showLoading();

    // Set active thumbnail in sidebar
    this.setActiveThumbnail(fileId);

    try {
      if (contentType.startsWith('image/')) {
        this.displayInlineImage(inlineUrl, fileName);
      } else if (contentType === 'application/pdf') {
        this.displayInlinePDF(inlineUrl, fileName);
      } else {
        this.showUnsupportedType();
      }
    } catch (error) {
      console.error('Inline viewing failed:', error);
      this.showError('Failed to load file for inline viewing');
    }
  }

  setupSidebarThumbnails() {
    // Find the side-right area in the files section
    const filesSection = this.fileGrid?.closest('.file-viewer-container');
    this.sideRight = filesSection?.querySelector('.side-right');

    if (!this.sideRight || !this.fileGrid) return;

    // Create sidebar wrapper for overlay containment
    const sidebarWrapper = document.createElement('div');
    sidebarWrapper.className = 'sidebar-thumbnail-wrapper';

    // Create sidebar thumbnail list container
    const sidebarList = document.createElement('div');
    sidebarList.id = 'sidebar-thumbnail-list';
    sidebarList.className = 'sidebar-thumbnail-list';

    // Create sidebar download overlay with localized text
    const sidebarOverlay = document.createElement('div');
    sidebarOverlay.id = 'sidebar-download-overlay';
    sidebarOverlay.className = 'sidebar-download-overlay';
    sidebarOverlay.style.display = 'none';

    // Get localized text
    const translations = document.getElementById('js-translations');
    const downloadingText = translations ?
      translations.dataset.downloadingText :
      'Loading file.';

    sidebarOverlay.innerHTML = `<span>${downloadingText} <span class="loading-dots"></span></span>`;

    // Clone thumbnails to sidebar
    const fileItems = this.fileGrid.querySelectorAll('.file-item');
    fileItems.forEach(item => {
      const clone = item.cloneNode(true);
      const fileHash = item.dataset.fileHash;
      const projectId = item.dataset.projectId;

      // Remove original download link from clone
      const originalDownloadLink = clone.querySelector('.file-actions');
      if (originalDownloadLink) originalDownloadLink.remove();

      // Add new download link after file meta using template
      const fileMeta = clone.querySelector('.file-meta');
      if (fileMeta && fileHash && projectId) {
        // Get the download link template
        const template = document.getElementById('sidebar-download-template');
        if (template) {
          const downloadLinkClone = template.content.cloneNode(true);
          const downloadLink = downloadLinkClone.querySelector('.sidebar-download-link');

          // FIXED: Set proper href for HTML-only downloads (no more JavaScript handling)
          // Get file ID from original item and construct download URL
          const fileId = item.dataset.fileId;
          if (fileId && projectId) {
            downloadLink.href = `/projects/${projectId}/files/${fileId}/download`;
          }

          // Keep data attributes for backward compatibility (though not used anymore)
          downloadLink.dataset.fileHash = fileHash;
          downloadLink.dataset.projectId = projectId;

          // Insert after file meta
          fileMeta.parentNode.insertBefore(downloadLinkClone, fileMeta.nextSibling);
        }
      }

      sidebarList.appendChild(clone);
    });

    // Add event delegation for sidebar thumbnail clicks only
    sidebarList.addEventListener('click', (e) => {
      // Check if click is on thumbnail container or its children
      const thumbnailContainer = e.target.closest('.file-thumbnail-container');
      if (thumbnailContainer) {
        const fileItem = thumbnailContainer.closest('.file-item');
        if (fileItem) {
          const thumbnail = fileItem.querySelector('.file-thumbnail[data-action="inline"]');
          if (thumbnail) {
            this.openInlineView(thumbnail);
          }
        }
      }
    });

    // Assemble the wrapper structure
    sidebarWrapper.appendChild(sidebarList);
    sidebarWrapper.appendChild(sidebarOverlay);
    this.sideRight.appendChild(sidebarWrapper);
    this.thumbnailsCloned = true;
  }

  activateViewerLayout() {
    // Find the parent flex container
    const flexContainer = this.fileGrid?.closest('.file-viewer-container');
    if (flexContainer) {
      flexContainer.classList.add('viewer-active');
    }
  }

  deactivateViewerLayout() {
    // Find the parent flex container
    const flexContainer = this.fileGrid?.closest('.file-viewer-container');
    if (flexContainer) {
      flexContainer.classList.remove('viewer-active');
    }
  }

  setActiveThumbnail(fileId) {
    // Remove active class from all thumbnails in sidebar
    const sidebarList = document.getElementById('sidebar-thumbnail-list');
    if (sidebarList) {
      sidebarList.querySelectorAll('.file-item').forEach(item => {
        item.classList.remove('active');
      });

      // Add active class to current file
      const activeItem = sidebarList.querySelector(`[data-file-id="${fileId}"]`);
      if (activeItem) {
        activeItem.classList.add('active');
      }
    }
  }

  displayInlineImage(url, fileName) {
    const img = new Image();

    img.onload = () => {
      this.viewerContent.innerHTML = '';
      img.alt = fileName;
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      this.viewerContent.appendChild(img);
    };

    img.onerror = () => {
      this.showError('Failed to load image');
    };

    img.src = url;
  }

  displayInlinePDF(url, fileName) {
    const iframe = document.createElement('iframe');
    iframe.src = `${url}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`;
    iframe.style.width = '100%';
    iframe.style.height = '600px';
    iframe.style.border = 'none';
    iframe.style.borderRadius = '4px';
    iframe.title = fileName;

    // SAFARI FIX: Safari requires sandbox attribute for PDF rendering
    // Chrome works without sandbox, so only add for Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      // allow-same-origin: Allows PDF to load from same domain
      // No scripts needed for static PDF viewing - safer this way
      iframe.sandbox = 'allow-same-origin';
    }

    this.viewerContent.innerHTML = '';
    this.viewerContent.appendChild(iframe);
  }

  showInlineViewer() {
    if (this.inlineViewer) {
      this.inlineViewer.style.display = 'block';
      // Don't scroll since we're reorganizing the layout
    }
  }

  closeInlineView() {
    if (this.inlineViewer) {
      this.inlineViewer.style.display = 'none';
      this.viewerContent.innerHTML = '';
      this.deactivateViewerLayout();
    }
  }

  showLoading() {
    this.viewerContent.innerHTML = '<div style="text-align: center; padding: 2rem;"><p>Loading file...</p></div>';
  }

  showError(message) {
    this.viewerContent.innerHTML = `<div style="text-align: center; padding: 2rem; color: #dc3545;"><p>${message}</p></div>`;
  }

  showUnsupportedType() {
    this.viewerContent.innerHTML = '<div style="text-align: center; padding: 2rem; color: #6c757d;"><p>Inline preview not available for this file type</p></div>';
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SecureFileViewer();
  new InlineFileViewer();
});

document.addEventListener('DOMContentLoaded', function() {
  const phoneInput = document.getElementById('user_profile_phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 0) {
        // Basic formatting - adjust pattern as needed
        if (value.length <= 3) {
          value = '+' + value;
        } else if (value.length <= 6) {
          value = '+' + value.substring(0, 3) + ' ' + value.substring(3);
        } else if (value.length <= 9) {
          value = '+' + value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
        } else {
          value = '+' + value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6, 9) + ' ' + value.substring(9);
        }
      }
      e.target.value = value;
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const currentLanguage = document.getElementById('currentLanguage');
  const languageMenu = document.getElementById('languageMenu');

  if (currentLanguage && languageMenu) {
    // Toggle dropdown on click
    currentLanguage.addEventListener('click', (event) => {
      event.stopPropagation();
      languageMenu.classList.toggle('hidden');
      // Close helpdesk menu if open
      const helpdeskMenu = document.getElementById('helpdeskMenu');
      if (helpdeskMenu) {
        helpdeskMenu.classList.add('hidden');
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!currentLanguage.contains(event.target) && !languageMenu.contains(event.target)) {
        languageMenu.classList.add('hidden');
      }
    });

    // Update current language display when selecting a new language
    languageMenu.querySelectorAll('.language-dropdown__item').forEach(link => {
      link.addEventListener('click', () => {
        const newLanguage = link.textContent;
        currentLanguage.textContent = newLanguage;
        languageMenu.classList.add('hidden');
      });
    });
  }
});

// Helpdesk dropdown functionality
document.addEventListener('DOMContentLoaded', () => {
  const helpdeskToggle = document.getElementById('helpdeskToggle');
  const helpdeskMenu = document.getElementById('helpdeskMenu');

  if (helpdeskToggle && helpdeskMenu) {
    // Toggle dropdown on click
    helpdeskToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      helpdeskMenu.classList.toggle('hidden');
      // Close language menu if open
      const languageMenu = document.getElementById('languageMenu');
      if (languageMenu) {
        languageMenu.classList.add('hidden');
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!helpdeskToggle.contains(event.target) && !helpdeskMenu.contains(event.target)) {
        helpdeskMenu.classList.add('hidden');
      }
    });
  }
});

// Admin dropdown functionality - click-based only
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize admin dropdowns if we're on an admin page
  if (document.querySelector('.modern-admin-container')) {
    initAdminDropdowns();
  }
});

function initAdminDropdowns() {
  document.addEventListener('click', (e) => {
    const dropdownButton = e.target.closest('.dropdown .action-icon-btn.action-icon-gray');
    const dropdown = e.target.closest('.dropdown');

    if (dropdownButton) {
      e.preventDefault();
      e.stopPropagation();

      // Close all other dropdowns
      document.querySelectorAll('.dropdown.active').forEach(dd => {
        if (dd !== dropdown) {
          dd.classList.remove('active');
        }
      });

      // Toggle current dropdown
      dropdown.classList.toggle('active');
    } else if (!e.target.closest('.dropdown-menu')) {
      // Close all dropdowns if clicking outside
      document.querySelectorAll('.dropdown.active').forEach(dd => {
        dd.classList.remove('active');
      });
    }
  });
}